'use client';

import { useAuthStore } from '@/store';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { Embedly } from '../../public/images';

export default function NotFound() {
  const router = useRouter();
  const hasHydrated = useAuthStore((state) => state.hasHydrated);
  const storedIsAuthenticated = useAuthStore((state) => state.isAuthenticated);
  // Before the persisted store rehydrates on a hard reload, isAuthenticated
  // defaults to false — treat that window as "not authenticated" rather
  // than risk sending an already-authenticated user to /login.
  const isAuthenticated = hasHydrated && storedIsAuthenticated;

  const handleRedirect = () => {
    router.push(isAuthenticated ? '/dashboard' : '/login');
  };

  return (
    <div className='min-h-screen flex flex-col items-center justify-center text-center p-4'>
      <Image src={Embedly} alt='embedly logo' className='mb-5' />
      <h1 className='text-4xl font-bold mb-4'>404 - Page Not Found</h1>
      <p className='text-lg mb-6'>{`Oops! The page you're looking for doesn't exist.`}</p>
      <button
        onClick={handleRedirect}
        className='cursor-pointer bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition'
      >
        {isAuthenticated ? 'Go to Dashboard' : 'Go to Login'}
      </button>
    </div>
  );
}
